export default __webpack_public_path__ + "media/SuccessImage.c648812d.png";